export default __webpack_public_path__ + "static/media/webino.fe2a7fdf.jpg";